/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { gql } from '@apollo/client';

export const GetSimulationCompanyCcnOfferQuery = gql`
  query GetSimulationCompanyCcnOfferQuery($ccn: String, $college: String) {
    getSimulationCompanyCcnOffer_simulation_company(ccn: $ccn, college: $college) {
      ccnOffer 
    }
  }
`;

export default GetSimulationCompanyCcnOfferQuery;
